import { abyssColors } from '@/theme/colors';
import { Box, Stack, Typography } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

type DotProps = {
  contained?: boolean;
};

export const Dot = muiStyled(Box)(({ contained }: DotProps) => ({
  width: '0.8rem',
  height: '0.8rem',
  borderRadius: '1rem',
  aspectRatio: '1/1',
  backgroundColor: contained ? abyssColors.primary[300] : abyssColors.neutral[50],
  border: contained ? 'none' : `0.1rem solid ${abyssColors.primary[300]}`,
  zIndex: 2,
}));

export const TimeLine = muiStyled(Box)(() => ({
  position: 'absolute',
  height: 'calc(100% - 10rem)',
  width: '0.1rem',
  left: '0.4rem',
  transform: 'translateX(-50%)',
  zIndex: 1,
  marginTop: '1.6rem',
  background: abyssColors.primary[200],
}));

export const StatusChip = muiStyled(Stack)(() => ({
  padding: '0.2rem 0.6rem',
  borderRadius: '3.2rem',
  height: 'fit-content',
}));

export const Status = muiStyled(Typography)(() => ({
  fontSize: '1.2rem',
  fontWeight: 500,
  lineHeight: 'normal',
}));
